var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendar2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.233,
    height: 56.626,
    viewBox: "0 0 57.233 56.626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487",
    transform: "translate(-49.646 -436.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(-5950 -5728.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M6050.049,6191.154v-19.487h-49.7v39.7a3.654,3.654,0,0,0,3.653,3.653h21.2",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.399
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_212",
    "data-name": "Line 212",
    x2: 44.886,
    transform: "translate(6005.164 6183.271)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.399
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_213",
    "data-name": "Line 213",
    y1: 10.291,
    transform: "translate(6010.09 6165.536)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.399
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_214",
    "data-name": "Line 214",
    y1: 10.291,
    transform: "translate(6040.306 6165.536)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.399
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 13.958,
    cy: 13.958,
    r: 13.958,
    transform: "translate(6028.263 6193.546)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.399
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M6042.221,6201.226v6.279l4.105,3.793",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.399
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_215",
    "data-name": "Line 215",
    x2: 4.228,
    transform: "translate(6008.084 6191.591)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.126
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_216",
    "data-name": "Line 216",
    x2: 4.228,
    transform: "translate(6008.084 6199.491)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.126
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_217",
    "data-name": "Line 217",
    x2: 4.228,
    transform: "translate(6008.084 6207.39)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.126
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_218",
    "data-name": "Line 218",
    x2: 4.228,
    transform: "translate(6018.173 6191.591)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.126
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_219",
    "data-name": "Line 219",
    x2: 4.228,
    transform: "translate(6018.173 6199.491)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.126
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_220",
    "data-name": "Line 220",
    x2: 4.228,
    transform: "translate(6018.173 6207.39)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.126
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_221",
    "data-name": "Line 221",
    x2: 4.228,
    transform: "translate(6028.263 6191.591)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.126
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar2);
export default __webpack_public_path__ + "static/media/icon-calendar-2.bc53827b31091056912787b9a6f1520e.svg";
export { ForwardRef as ReactComponent };